import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import { extractKybReportDetails } from "src/modules/3rd-party-management/helpers/kybReports";
import { buildHandelsregisterExportSections } from "../../helpers/handelsregisterExport";
import { KeyValueTable } from "../../shared";
import ReportSectionBlock from "./ReportSectionBlock";

const HandelsregisterReport = ({ report }) => {
    const details = extractKybReportDetails(report);
    const sections = buildHandelsregisterExportSections(details?.company, details?.header);

    if (!details?.company || sections.length === 0) {
        return (
            <KeyValueTable
                rows={[]}
                emptyMessage="No Handelsregister data available"
            />
        );
    }

    return (
        <View>
            {sections.map((section, index) => (
                <ReportSectionBlock
                    key={`${section.title}-${index}`}
                    section={section}
                    breakBefore={index > 0 && index % 3 === 0}
                />
            ))}
        </View>
    );
};

export default withNamespaces()(HandelsregisterReport);
